/**
 * Reexport 'useTheme' from MUI to allow users of branch-neo-components
 * to use the compatible 'useTheme' helper with exported BranchTheme.
 *
 * Uses BranchTheme as a default Theme type.
 */
import { useTheme as muiUseTheme } from '@mui/styles';
function useTheme() {
    return muiUseTheme();
}
export { useTheme };
//# sourceMappingURL=useTheme.js.map